import styled from "styled-components";

export const Wrapper = styled.div`
background: #FFFFFF;
`;

export const Content = styled.div`
margin-top: 50px;
margin-left: 89px;
font-family: "Robotto";
@media screen and (max-width: 414px){
        margin-left: 5%;
    }
`;